<template>
  <div>
    <v-card class="card-info px-2" outlined id="amountcard" height="78px">
      <v-row dense align="center" class="fill-height">
        <v-col v-if="isLoad">
          <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        </v-col>
        <v-col v-else class="">
          <v-row dense class="total mt-1">
            <v-col>
              {{ currFormatter(value1) || '-' }}
              <span class="curr">BIDR</span>
            </v-col>
          </v-row>
          <v-row dense class="">
            <v-col class="total-eur pt-0">
              {{ eur(valueEur) || '-' }} MEUR
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="auto"
          class="fill-height d-flex align-center justify-center py-3"
        >
          <v-row
            style="width: 57px;"
            class="fill-height br-10 mx-1"
            justify="center"
            align="center"
            no-gutters
          >
            <v-col
              class="fill-height d-flex icon-card align-center icon text--white justify-center"
            >
              <v-icon size="35" color="#34CFAA" v-if="typeCard === 1"
                >ri-coins-line</v-icon
              >
              <v-icon size="35" color="#FA576E" v-if="typeCard === 2"
                >ri-coins-line</v-icon
              >
              <v-icon size="35" color="#28A0F6" v-if="typeCard === 3"
                >ri-file-list-3-line</v-icon
              >
              <v-icon size="35" color="#FF8B49" v-if="typeCard === 4"
                >ri-pie-chart-2-line</v-icon
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="card-info-2 px-2" outlined id="amountcard" height="44px"
      ><div class="d-flex justify-space-between">
        <v-row>
          <v-col cols="8.5">
            <h2 class="fs-12" :class="textColor">
              {{ text }}
            </h2>
          </v-col>
          <v-col
            cols="auto"
            class="text-right red--text title-percent title right-text"
            v-if="typeCard !== 1"
          >
            <v-row align="center" no-gutters class="">
              <v-col>
                <v-menu open-on-hover top offset-y>
                  <template v-slot:activator="{ on }">
                    <span
                      v-if="valuePercent.percentage.toFixed(0) < 100"
                      class="softRed--text"
                      v-on="on"
                    >
                      {{
                        valuePercent.percentage
                          ? valuePercent.percentage.toFixed(0) + '%'
                          : '0%'
                      }}
                    </span>
                    <span
                      v-else-if="valuePercent.percentage.toFixed(0) >= 100"
                      class="teal--text"
                      v-on="on"
                      >{{
                        valuePercent.percentage
                          ? valuePercent.percentage.toFixed(0) + '%'
                          : '0%'
                      }}</span
                    >
                  </template>
                  <v-card
                    flat
                    outlined
                    :elevation="0"
                    style="boder-radius: 25px !important"
                  >
                    <v-card-title
                      class="blue-grey lighten-5 fs-10 pa-0 grey--text text--darken-1"
                    >
                      <span v-if="typeCard === 2" class="pl-2"
                        >SPENDING IO</span
                      >
                      <span v-if="typeCard === 3" class="pl-2">PO</span>
                      <span v-if="typeCard === 4" class="pl-2">GR</span>
                    </v-card-title>
                    <v-card-text class="fs-10 grey--text text--darken-1 pa-2">
                      <v-flex xs12>
                        <v-icon :color="colour">fiber_manual_record</v-icon>
                        <span v-if="typeCard === 2" class="pt-3">
                          FY IO / FY Budget</span
                        >
                        <span v-if="typeCard === 3"> PO / IO YTD</span>
                        <span v-if="typeCard === 4"> GR / IO YTD</span>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col>
                <img
                  v-if="valuePercent.percentage.toFixed(0) < 100"
                  src="@/assets/images/icon/arrow-down.png"
                  width="15.5px"
                  class="ml-1"
                />
                <img
                  v-if="valuePercent.percentage.toFixed(0) >= 100"
                  src="@/assets/images/icon/arrow-up.png"
                  width="15.5px"
                  class="ml-1"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    colour: {
      type: String,
      required: true
    },
    typeCard: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    value1: {
      type: Number,
      required: true
    },
    valueEur: {
      type: Number,
      required: true
    },
    valuePercent: {
      type: Object,
      required: false
    },
    textColor: {
      type: String,
      required: false
    },
    isLoad: {
      type: Boolean,
      required: false
    }
  }
};
</script>
<style scoped>
.icon-card {
  font-size: 35px !important;
}
.v-menu__content {
  border-radius: 10px !important;
}
</style>
